export default __webpack_public_path__ + "static/media/Gloves of the Black Pharaoh.99233e87.jpg";